export default {
    props: {
        currentTimeMarkerUpdateInterval: {
            type: Number,
            default: undefined,
            kComposite: 'currentTimeMarker.updateInterval'
        }, 
        currentTimeMarkerUseLocalTimezone: {
            type: Boolean,
            default: undefined,
            kComposite: 'currentTimeMarker.useLocalTimezone'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/CurrentTimeMarker.js